/** Whether a note content holds text, once its HTML tags, non-breaking spaces and whitespace are dropped. */
export const hasNoteText = (content: string | null | undefined): boolean =>
  Boolean(
    content
      ?.replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, "")
      .trim()
  );
